import React, { useState } from "react";
import { Link } from "react-router-dom";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { mediaUrl, sectionBlocks, useSiteData } from "../lib/siteApi";

import blog1 from "../assets/images/solar/18.png";
import blog2 from "../assets/images/solar/17.jpg";
import blog3 from "../assets/images/solar/19.jpg";

const fallbackTabs = [
  {
    id: "mission",
    title: "Our Mission",
    body: "<p>Provide clean affordable energy that ensure generational sustainability through safe environment.</p><p>To provide innovative solutions in housing focusing on solving the existing challenges related to the highest cost of energy and instable electricity, safety and security faced by clients.</p>",
    image: blog1,
  },
  {
    id: "vision",
    title: "Our Vision",
    body: "<p>Being Rwandan leading quality solar solutions as well in the region, by providing access to renewable energy, quality solar services at standards level and by ensuring environment sustainability with the use of renewable energy.</p>",
    image: blog2,
  },
  {
    id: "values",
    title: "Fundamental Values",
    body: "<ul><li><strong>Integrity:</strong> we believe in transparent business practices that lead to mutually beneficial outcomes for all stakeholders.</li><li><strong>Trustworthy:</strong> RENERG keeps the promises made with clients.</li><li><strong>Innovation:</strong> we work on the cutting edge of solar, energy storage and grid modernization.</li><li><strong>Honesty:</strong> we tell our clients the truth about what they need and how it works.</li><li><strong>Professionalism:</strong> in construction and renewable energy.</li></ul>",
    image: blog3,
  },
];

export default function AgencyTab() {
  const site = useSiteData();
  const blocks = sectionBlocks(site.content, "values");
  const tabs = blocks.length
    ? blocks.map((block, index) => ({
        id: block.id || block.key || String(index),
        title: block.title || `Item ${index + 1}`,
        body: block.body || "",
        image: mediaUrl(block.imageUrl) || fallbackTabs[index % fallbackTabs.length].image,
      }))
    : fallbackTabs;
  const [activeIndex, setActiveIndex] = useState(0);
  const current = tabs[activeIndex] || tabs[0];
  if (!current) return null;

  return (
    <section className="relative bg-slate-50 py-16 md:py-24" id="values">
      <div className="container relative">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          <div className="md:col-span-5 lg:col-span-4">
            <div className="rounded-2xl bg-white p-4 shadow-lg">
              {tabs.map((tab, index) => {
                const on = index === activeIndex;
                return (
                  <div
                    key={tab.id}
                    role="button"
                    tabIndex={0}
                    onClick={() => setActiveIndex(index)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") setActiveIndex(index);
                    }}
                    className={`w-full cursor-pointer rounded-xl px-5 py-4 text-left transition ${on ? "bg-teal-500 text-white shadow-md" : "text-slate-800 hover:bg-slate-50"} ${index ? "mt-3" : ""}`}
                  >
                    <span className={`block text-lg font-semibold ${on ? "text-white" : "text-slate-900"}`}>{tab.title}</span>
                    <div className={`mt-2 text-sm leading-relaxed line-clamp-4 ${on ? "text-teal-50" : "text-slate-500"}`}>
                      <HtmlContent html={tab.body} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="md:col-span-7 lg:col-span-8">
            <div className="rounded-2xl bg-white p-5 shadow-lg sm:p-6">
              <PhotoLink to="/about#values" src={current.image} alt={current.title} className="h-56 w-full rounded-xl object-cover sm:h-72" wrapClassName="block overflow-hidden rounded-xl" />
              <h3 className="renerg-h3 mt-6 text-slate-900">{current.title}</h3>
              <div className="renerg-body mt-4 text-slate-600">
                <HtmlContent html={current.body} imageTo="/about#values" />
              </div>
              <Link to="/about" className="mt-5 inline-flex font-semibold text-teal-700">Read the full story →</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
